import React from "react";
import { Column, Columns, Control, Input } from "@allxsmith/bestax-bulma";



export default function HireAgreementSection({financeAgreement, onChange}){

    return (
        <div>
            <Columns isMultiline>
                <Column>
                    <label className="label">Start Date</label>
                    <Control>
                        <Input
                            type={"date"}
                            onChange={(e) => onChange(e)}
                            value={financeAgreement.hire_start_date}
                            name={"hire_start_date"}
                        />
                    </Control>
                </Column>
                <Column>
                    <label className="label">End Date</label>
                    <Control>
                        <Input
                            type={"date"}
                            onChange={(e) => onChange(e)}
                            value={financeAgreement.end_date}
                            name={"end_date"}
                        />
                    </Control>
                </Column>
                <Column>
                    <label className="label">Daily Rate</label>
                    <Control>
                        <Input
                            type={"number"}
                            onChange={(e) => onChange(e)}
                            value={financeAgreement.daily_rate}
                            name={"daily_rate"}
                        />
                    </Control>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <label className="label">Mileage Allowance</label>
                    <Control>
                        <Input
                            type={"number"}
                            onChange={(e) => onChange(e)}
                            value={financeAgreement.mileage_allowance}
                            name={"mileage_allowance"}
                        />
                    </Control>
                </Column>
                <Column>
                    <label className="label">On Hire Mileage</label>
                    <Control>
                        <Input
                            type={"number"}
                            onChange={(e) => onChange(e)}
                            value={financeAgreement.on_hire_mileage}
                            name={"on_hire_mileage"}
                        />
                    </Control>
                </Column>
            </Columns>
        </div>
    );



}